import { render, staticRenderFns } from "./ButtonSeven.vue?vue&type=template&id=e65c3182&"
import script from "./ButtonSeven.vue?vue&type=script&lang=ts&"
export * from "./ButtonSeven.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports